class DelayedSentryFn {
  private arguments: any[] = [];

  public constructor(
    private originalFnName: string,
    private originalMethods: any,
  ) {}

  proxyMethod(...args: any[]) {
    if (this.originalMethods[this.originalFnName]) {
      this.originalMethods[this.originalFnName](...args);
    } else {
      this.arguments.push(args);
    }
  }

  originalLoaded() {
    if (this.arguments.length && this.originalMethods[this.originalFnName]) {
      this.arguments.forEach(argument => {
        this.originalMethods[this.originalFnName](...argument);
      });
    }
  }
}

const originalMethods: any = {};
const proxyMethods = {
  proxyCaptureExceptionSentry: new DelayedSentryFn('captureExceptionSentry', originalMethods),
  proxySentryCaptureMessage: new DelayedSentryFn('sentryCaptureMessage', originalMethods),
  proxyUseSentry: new DelayedSentryFn('useSentry', originalMethods),
};

import('./useSentry').then(sentryModule => {
  originalMethods.captureExceptionSentry = sentryModule.captureExceptionSentry;
  originalMethods.sentryCaptureMessage = sentryModule.sentryCaptureMessage;
  originalMethods.useSentry = sentryModule.useSentry;
  Object.values(proxyMethods).forEach(method => {
    method.originalLoaded();
  });
});

export const useSentryAsync = () => {
  return {
    captureExceptionSentry: proxyMethods.proxyCaptureExceptionSentry.proxyMethod.bind(proxyMethods.proxyCaptureExceptionSentry),
    sentryCaptureMessage: proxyMethods.proxySentryCaptureMessage.proxyMethod.bind(proxyMethods.proxySentryCaptureMessage),
    useSentry: proxyMethods.proxyUseSentry.proxyMethod.bind(proxyMethods.proxyUseSentry),
  };
};
